import * as React from "react"
import PrayerCalendar from '../PrayerCalendar';
import PrayerSettingsList from '../PrayerSettingsList';

const PrayerPage = () => {
	return (
		<div className="grid">
			<div className=" grid grid-cols-2  grid-flow-row ">
				<PrayerSettingsList />
				<PrayerCalendar show={ false } />
			</div>
		</div>
	);
};

export default PrayerPage;
